module.exports = __webpack_public_path__ + "img/1515059295.f2def5ad.jpg";